import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import ActivityLog from './ActivityLog';
import api from '../utils/api';

const PAGE_MAP = { '/': 'POS', '/orders': 'Orders', '/reports': 'Reports', '/discounts': 'Discounts', '/manage-products': 'Products', '/access-control': 'Access Control', '/eod-report': 'EOD Report', '/inventory': 'Inventory', '/activity-log': 'Activity Log' };

function Layout() {
  const location = useLocation();
  const prevPageRef = useRef(null);
  const [activityLogOpen, setActivityLogOpen] = useState(false);

  useEffect(() => {
    const toggle = () => setActivityLogOpen(prev => !prev);
    window.addEventListener('toggle-activity-log', toggle);
    return () => window.removeEventListener('toggle-activity-log', toggle);
  }, []);

  useEffect(() => {
    const page = PAGE_MAP[location.pathname] || location.pathname;
    const referrerPage = prevPageRef.current;
    const locationId = localStorage.getItem('selectedLocation') || '';
    api.post('/events/page-view', { page, referrerPage, locationId }).catch(() => {});
    prevPageRef.current = page;
  }, [location.pathname]);

  return (
    <div className="app-bg" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, padding: '20px 24px' }}>
        <Outlet />
      </main>
      <ActivityLog isOpen={activityLogOpen} onClose={() => setActivityLogOpen(false)} />
    </div>
  );
}

export default Layout;
